import React from "react"
// import logo from "../../assets/images/Logo.png"
import "./header.css"
import { User } from "./User"
import { nav } from "../../assets/data/data"
import { Link } from "react-router-dom"

export const Header = () => {
   window.addEventListener("scroll", function () {
    const header = this.document.querySelector(".header")
    header.classList.toggle("active", this.window.scrollY > 100)
  }) 
  return (
    <>
      <header className='header'>
        <div className='scontainer flex'>
          <div className='logo'>
            <h1 className="logo-heading">PressBee</h1>
          </div>
          <nav>
            {/* <ul>
              {nav.map((link) => (
                <li key={link.id}>
                  <Link to={link.url}>{link.text}</Link>
                </li>
              ))}
            </ul> */}
            <div>
            <input type="text" placeholder="Search..." className="search flexCenter"/>
          </div>
          </nav>
          <div className='account flexCenter'>
            <Link to="/login" className='tab'>Login</Link>
            <Link to="/register" className='tab'>Register</Link>
           
          </div>
        </div>
      </header>
    </>
  )
}
